import { useMutation } from "@/core/api/graphql/composables";
import { UpdateCustomerOrderWantsInvoicePdfDocument } from "@/core/api/graphql/types";

export function useUpdateCustomerOrderWantsInvoicePdfMutation() {
  return useMutation(UpdateCustomerOrderWantsInvoicePdfDocument);
}
